import { BufferGeometry, Material, Scene } from "three";
import { MaterialGeometryCache } from "./MaterialGeometryCache";

export type ActiveSceneMaterialSummaryRow = {
  uuid: string;
  name: string;
  type: string;
  geometryCount: number;
};

/**
 * `MaterialGeometryCache` ile aynı mesh kuralları; sahne + önbellek üzerinden okuma.
 */
export function listActiveSceneMaterials(
  cache: MaterialGeometryCache,
  scene: Scene | undefined,
): Material[] {
  if (!scene) return [];
  cache.sync(scene);
  const list = Array.from(cache.getBuckets().keys());
  list.sort((a, b) =>
    a.uuid.localeCompare(b.uuid, undefined, { numeric: true }),
  );
  return list;
}

export function summarizeActiveSceneMaterials(
  cache: MaterialGeometryCache,
  scene: Scene | undefined,
): ActiveSceneMaterialSummaryRow[] {
  if (!scene) return [];
  cache.sync(scene);
  const rows: ActiveSceneMaterialSummaryRow[] = [];
  for (const [mat, geoms] of cache.getBuckets()) {
    rows.push({
      uuid: mat.uuid,
      name: mat.name || "(unnamed)",
      type: mat.type,
      geometryCount: geoms.length,
    });
  }
  rows.sort((a, b) =>
    a.uuid.localeCompare(b.uuid, undefined, { numeric: true }),
  );
  return rows;
}

export function logActiveSceneMaterialsToConsole(
  cache: MaterialGeometryCache,
  scene: Scene | undefined,
  label = "activeScene materials",
): void {
  const rows = summarizeActiveSceneMaterials(cache, scene);
  console.info(`[ActiveSceneMaterials] ${label}: ${rows.length} materyal`);
  console.table(rows);
}
